import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import {
  composeSDKFactories,
  createElementPropsSDKFactory,
  linkPropsSDKFactory,
  withValidation,
  createAccessibilityPropSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import type {
  TextMarqueeProps,
  TextMarqueeSDKFactory,
  TextMarqueeSDKArgs,
} from '../TextMarquee.types';

const accessibilityPropsSDKFactory = createAccessibilityPropSDKFactory({
  enableAriaHidden: true,
  enableScreenReader: true,
});

const textMarqueeSDK: TextMarqueeSDKFactory = ({
  props,
  setProps,
}: TextMarqueeSDKArgs) => {
  return {
    get text() {
      return props.singleTextItem.text;
    },
    set text(value) {
      setProps({ singleTextItem: { ...props.singleTextItem, text: value } });
    },
  };
};

const schema: ValidationSchema = {
  type: ['object'],
  properties: {
    text: {
      type: ['string'],
      minLength: 1,
      maxLength: 500,
    },
  },
};

export const textMarqueeSDKFactory = withValidation(textMarqueeSDK, schema);

export default createComponentSDKModel(
  composeSDKFactories<TextMarqueeProps, TextMarqueeSDKFactory>([
    createElementPropsSDKFactory(),
    linkPropsSDKFactory,
    accessibilityPropsSDKFactory,
    textMarqueeSDKFactory,
  ]),
);
